import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Пакет бумажный 25х35х8cм. Внутри белый.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
